
import React from 'react';

const PlateformesSection = () => {
  const plateformes = [
    { nom: "LinkedIn", usage: "B2B, networking professionnel", couleur: "bg-blue-600" },
    { nom: "Instagram", usage: "Visual storytelling, B2C", couleur: "bg-pink-500" },
    { nom: "Facebook", usage: "Communauté, publicité ciblée", couleur: "bg-blue-500" },
    { nom: "Twitter/X", usage: "Actualités, thought leadership", couleur: "bg-black" },
    { nom: "YouTube", usage: "Vidéos, tutoriels", couleur: "bg-red-500" },
    { nom: "TikTok", usage: "Contenu viral, Gen Z", couleur: "bg-black" }
  ];

  return (
    <section className="py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-light text-navy-900 mb-6">
              Plateformes <span className="font-semibold text-blue-600">maîtrisées</span>
            </h2>
            <p className="text-lg text-navy-600 font-light max-w-2xl mx-auto">
              Chaque plateforme a ses codes, j'adapte votre message pour maximiser l'impact
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {plateformes.map((plateforme, index) => (
              <div key={index} className="bg-white border border-navy-100 p-6 hover:shadow-lg transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className={`${plateforme.couleur} w-12 h-12 flex items-center justify-center text-white font-bold`}>
                    {plateforme.nom.charAt(0)}
                  </div>
                  <div>
                    <h3 className="font-semibold text-navy-900">{plateforme.nom}</h3>
                    <p className="text-sm text-navy-600 font-light">{plateforme.usage}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlateformesSection;
